import { useNavigate } from 'react-router-dom';

interface MainSidebarContentProps {
  currentPage?: 'chat' | 'projects' | 'history' | 'agents';
  onNewChat?: () => void;
  onShowHistory?: () => void;
}

export default function MainSidebarContent({ 
  currentPage = 'chat',
  onNewChat,
  onShowHistory
}: MainSidebarContentProps) {
  const navigate = useNavigate();

  return (
    <>
      <button
        onClick={onNewChat || (() => navigate('/'))}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          padding: '10px 14px',
          background: 'var(--accent)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          width: '100%',
          transition: 'opacity 0.15s',
          whiteSpace: 'nowrap'
        }}
        onMouseOver={(e) => { e.currentTarget.style.opacity = '0.85'; }}
        onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; }}
      >
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '16px', height: '16px' }}>
          <line x1="10" y1="5" x2="10" y2="15"/><line x1="5" y1="10" x2="15" y2="10"/>
        </svg>
        New Chat
      </button>

      {/* Agents Section */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <div style={{
          fontSize: '10px',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'var(--text-muted)',
          padding: '0 0 2px 0'
        }}>
          Agents
        </div>
        <button
          type="button"
          onClick={() => navigate('/settings/addagent')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 10px',
            background: 'transparent',
            border: 'none',
            borderRadius: '8px',
            color: 'var(--text)',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: 'inherit',
            transition: 'background 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = 'var(--surface2)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--text-muted)' }}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="16"/>
            <line x1="8" y1="12" x2="16" y2="12"/>
          </svg>
          <span style={{ flex: 1 }}>New Agent</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/agents')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 10px',
            background: 'transparent',
            border: 'none',
            borderRadius: '8px',
            color: 'var(--text)',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: 'inherit',
            transition: 'background 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = 'var(--surface2)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--text-muted)' }}>
            <rect x="3" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="14" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/>
          </svg>
          <span style={{ flex: 1 }}>Agent Store</span>
        </button>
      </div>

      {/* Projects Section */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '12px' }}>
        <div style={{
          fontSize: '10px',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'var(--text-muted)',
          padding: '0 0 2px 0'
        }}>
          Projects
        </div>
        <button
          type="button"
          onClick={() => navigate('/projects')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 10px',
            background: currentPage === 'projects' ? 'var(--surface2)' : 'transparent',
            border: 'none',
            borderRadius: '8px',
            color: 'var(--text)',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: 'inherit',
            transition: 'background 0.2s ease'
          }}
          onMouseOver={(e) => {
            if (currentPage !== 'projects') {
              e.currentTarget.style.background = 'var(--surface2)';
            }
          }}
          onMouseOut={(e) => {
            if (currentPage !== 'projects') {
              e.currentTarget.style.background = 'transparent';
            }
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--text-muted)' }}>
            <path d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2z"/>
            <line x1="9" y1="13" x2="15" y2="13"/>
            <line x1="12" y1="10" x2="12" y2="16"/>
          </svg>
          <span style={{ flex: 1 }}>All Projects</span>
        </button>
      </div>

      {/* History Section */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '12px' }}>
        <div style={{
          fontSize: '10px',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'var(--text-muted)',
          padding: '0 0 2px 0'
        }}>
          History
        </div>
        <button
          type="button"
          onClick={onShowHistory || (() => navigate('/'))}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 10px',
            background: 'transparent',
            border: 'none',
            borderRadius: '8px',
            color: 'var(--text)',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: 'inherit',
            transition: 'background 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = 'var(--surface2)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent';
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: '16px', height: '16px', flexShrink: 0, color: 'var(--text-muted)' }}>
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
          <span style={{ flex: 1 }}>View All</span>
        </button>
      </div>
    </>
  );
}
